export const createPendingDataEntries = <T, K extends string>(key: K, num: number) => {
  type ObjectType = { [k in K]: null | T; } & { pending: boolean; };
  return Array.from(new Array(num)).map<ObjectType>(_ => ({
    [key]: null,
    pending: true,
  } as ObjectType));
}